module.exports = __webpack_public_path__ + "static/media/favicon.2862a3da.ico";